import { useState } from "react";

const questionsData = {
  consignado: [
    {
      number: "01.",
      question: "Quais são os requisitos básicos para contratar um crédito consignado INSS?",
      answer:
        "Para contratar um crédito consignado INSS, é necessário ser aposentado ou pensionista do INSS, ter margem consignável disponível e estar dentro dos critérios estabelecidos pela instituição financeira, como idade e outros requisitos específicos.",
    },
    {
      number: "02.",
      question: "Como funciona a portabilidade de crédito consignado?",
      answer:
        "A documentação geralmente inclui comprovante de identidade (RG e CPF), comprovante de residência, comprovante de renda, extrato do benefício do INSS e, em alguns casos, documentos adicionais exigidos pela instituição financeira.",
    },
    {
      number: "03.",
      question: "Qual é a documentação necessária para solicitar um crédito consignado INSS?",
      answer:
        "As principais vantagens da portabilidade de crédito consignado incluem a possibilidade de reduzir as taxas de juros, alongar o prazo de pagamento, diminuir o valor das parcelas mensais, e obter condições mais favoráveis de acordo com o perfil e a negociação do cliente. Isso pode",
    },
    {
      number: "04.",
      question:
        "Como posso verificar minha margem consignável para contratar um crédito consignado no INSS?",
      answer:
        "A margem consignável pode ser verificada no site do INSS, no portal Meu INSS, onde o beneficiário pode acessar informações sobre seu benefício, incluindo a margem disponível para empréstimos consignados.",
    },
    {
      number: "05.",
      question:
        "A margem consignável pode ser verificada no site do INSS, no portal Meu INSS, onde o beneficiário pode acessar informações sobre seu benefício, incluindo a margem disponível para empréstimos consignados.",
      answer: (
        <>
          1. Ser Aposentado ou Pensionista do INSS
          <br />
          2. CPF em situação regular na Receita Federal
          <br />
          3. Ter uma conta nominal para receber o crédito
          <br />
          4. Realizar simulação de crédito
          <br />
          5. Autorizar o banco a consultar sua margem para Consignado INSS
          <br />
          6. Aprovar a simulação de Crédito
        </>
      ),
    },
    {
      number: "06.",
      question: "Existe alguma restrição de idade para contratar um crédito consignado INSS?",
      answer:
        "Sim, algumas instituições financeiras podem impor restrições de idade para a concessão do crédito consignado INSS. Geralmente, o beneficiário deve ter idade inferior a 80 anos na data de quitação do empréstimo, mas as condições podem variar entre os bancos.",
    },
    {
      number: "07.",
      question:
        "Qual é o limite de comprometimento de renda para contratar um crédito consignado INSS?",
      answer:
        "As principais vantagens da portabilidade de crédito consignado incluem a possibilidade de reduzir as taxas de juros, alongar o prazo de pagamento, diminuir o valor das parcelas mensais, e obter condições mais favoráveis de acordo com o perfil e a negociação do cliente. Isso pode",
    },
    {
      number: "08.",
      question: "Posso contratar mais de um crédito consignado INSS ao mesmo tempo?",
      answer:
        "Sim, é possível contratar mais de um crédito consignado INSS, desde que o somatório das parcelas não ultrapasse o limite de 35% da renda mensal do beneficiário. Cada empréstimo é analisado individualmente em relação à margem consignável disponível.",
    },
    {
      number: "09.",
      question: "Como é feita a quitação antecipada de um crédito consignado INSS?",
      answer:
        "A quitação antecipada do crédito consignado INSS pode ser realizada a qualquer momento. O beneficiário deve entrar em contato com a instituição financeira, verificar o saldo devedor atualizado e solicitar informações sobre os procedimentos para antecipação de pagamento.",
    },
  ],
  portabilidade: [
    {
      number: "01.",
      question: "O que é portabilidade de crédito consignado?",
      answer:
        "A portabilidade de crédito consignado é a transferência de um empréstimo consignado de uma instituição financeira para outra, com o objetivo de obter melhores condições de pagamento, como taxas de juros mais baixas ou prazos mais vantajosos. Essa operação permite ao tomador do crédito migrar seu débito sem alterar as condições originais do contrato, exceto pela instituição credora e possíveis benefícios acordados.",
    },
    {
      number: "02.",
      question: "Como funciona a portabilidade de crédito consignado?",
      answer:
        "A portabilidade de crédito consignado funciona da seguinte forma: o cliente solicita a portabilidade à nova instituição financeira, que faz uma proposta ao cliente com novas condições (taxas de juros, prazos, etc.). Se o cliente aceitar a proposta, a nova instituição financeira quita o saldo devedor na instituição original e assume o crédito. O cliente passa a pagar as parcelas à nova instituição, conforme as condições acordadas.",
    },
    {
      number: "03.",
      question: "Quais são as vantagens da portabilidade de crédito consignado?",
      answer:
        "As principais vantagens da portabilidade de crédito consignado incluem a possibilidade de reduzir as taxas de juros, alongar o prazo de pagamento, diminuir o valor das parcelas mensais, e obter condições mais favoráveis de acordo com o perfil e a negociação do cliente. Isso pode",
    },
  ],
  fgts: [
    {
      number: "01.",
      question: "O que é saldo FGTS?",
      answer:
        "O Fundo de Garantia do Tempo de Serviço (FGTS) é um dos principais direitos garantidos aos trabalhadores com carteira assinada no Brasil. Ele é um fundo criado pelo governo federal e funciona como uma poupança. Todo mês, a empresa deposita o valor correspondente a 8% do salário do funcionário, sem desconto ao empregado. O saldo pode ser resgatado em algumas situações como demissão, financiamento imobiliário, saque-aniversário ou campanhas específicas promovidas pelo governo federal.",
    },
    {
      number: "02.",
      question: "O que é Antecipação do Saque Aniversário FGTS?",
      answer:
        "É uma nova modalidade de crédito que permite a antecipação do saque-aniversário dos próximos anos com taxas de juros atrativas.",
    },
    {
      number: "03.",
      question: "Como funciona a antecipação do Saque Aniversário FGTS?",
      answer:
        "Funciona como um empréstimo com garantia. Ao escolher esse crédito, você irá antecipar o saque do mês do seu aniversário e receber o dinheiro em até 24 horas na conta cadastrada na Santana Cred. A diferença é que as parcelas serão pagas anualmente pela Caixa direto do seu FGTS, ao invés de serem pagas mensalmente por você.",
    },
    {
      number: "04.",
      question: "O que é preciso para ser elegível a oferta?",
      answer: (
        <>
          1. Ser maior de 18 anos;
          <br />
          2. CPF em situação regular na Receita Federal;
          <br />
          3. Ter conta corrente ou poupança;
          <br />
          4. Optar pelo saque de aniversário;
          <br />
          5. Autorizar o banco a acessar seus dados e valores do FGTS;
          <br />
          6. Aprovação da simulação.
        </>
      ),
    },
    {
      number: "05.",
      question: "Quanto de saldo no FGTS preciso ter para contratar?",
      answer: "Ter saldo mínimo no FGTS de R$1.500,00.",
    },
    {
      number: "06.",
      question: "Consigo antecipar todo o meu saldo do FGTS?",
      answer:
        "Não, somente parte do seu saldo. Para saber o valor exato que você pode receber você precisa entrar em contato com a Santana Cred e conversar com nosso time de especialistas que irão tirar todas as suas dúvidas.",
    },
    {
      number: "07.",
      question: "Como fazer a adesão da modalidade Saque Aniversário do FGTS?",
      answer: (
        <>
          É bem simples, siga os passos abaixo:
          <br />
          1. Acesse o aplicativo “FGTS”;
          <br />
          2. Toque na opção “Saque-Aniversário do FGTS”;
          <br />
          3. Leia atentamente e marque a opção de “termos e condições;
          <br />
          4. Toque no botão “Empréstimo Saque aniversário.
          <br />
          <a
            href="https://play.google.com/store/apps/details?id=br.gov.caixa.fgts.trabalhador&hl=pt_BR&gl=US"
            target="_blank"
            rel="noreferrer"
          >
            Aplicativo FGTS - Google Play
          </a>
          <br />
          <a
            href="https://apps.apple.com/br/app/fgts/id1038441027"
            target="_blank"
            rel="noreferrer"
          >
            Aplicativo FGTS - App Store
          </a>
        </>
      ),
    },
    {
      number: "08.",
      question: "Quantas parcelas do Saque Aniversário eu posso antecipar?",
      answer:
        "Aqui, na Santana Cred, você pode antecipar o valor de até 10 (dez) parcelas anuais do seu Saque Aniversário, desde que haja saldo em sua conta FGTS.",
    },
  ],
};

type doubts = "consignado" | "portabilidade" | "fgts";
export const Duvidas = () => {
  const [selectedCategory, setSelectedCategory] = useState<doubts>("consignado");
  const [openQuestionIndex, setOpenQuestionIndex] = useState<number | null>(null);

  const handleCategoryClick = (category: doubts) => {
    setSelectedCategory(category);
    setOpenQuestionIndex(null);
  };

  const toggleQuestion = (index: number) => {
    setOpenQuestionIndex(openQuestionIndex === index ? null : index);
  };

  return (
    <div className="bg-white pb-4 pt-20">
      <h2 className="heading-2 z-10 grid h-full w-full place-content-center text-center uppercase text-black">
        Dúvidas Frequentes
      </h2>
      <div className="content-area py-28">
        <div className="mx-auto max-w-[63rem]">
          <ul className="mb-12 grid grid-cols-1 justify-center gap-8 px-8 md:grid-cols-[repeat(3,11rem)] md:px-0 lg:grid-cols-[repeat(3,11rem)]">
            <li
              className={`btn-text-2 grid h-[5.5rem] cursor-pointer place-content-center rounded-lg border text-center 
              ${selectedCategory === "consignado"
                  ? "bg-black text-white"
                  : "border-black bg-white text-black"
                }`}
              onClick={() => handleCategoryClick("consignado")}
            >
              Crédito <br /> Consignado
            </li>
            <li
              className={`btn-text-2 grid h-[5.5rem] cursor-pointer place-content-center rounded-lg border text-center ${selectedCategory === "portabilidade"
                  ? "bg-black text-white"
                  : "border-black bg-white text-black"
                }`}
              onClick={() => handleCategoryClick("portabilidade")}
            >
              Portabilidade &amp; <br /> Refinanciamento
            </li>
            <li
              className={`btn-text-2 grid h-[5.5rem] cursor-pointer place-content-center rounded-lg border text-center ${selectedCategory === "fgts"
                  ? "bg-black text-white"
                  : "border-black bg-white text-black"
                }`}
              onClick={() => handleCategoryClick("fgts")}
            >
              FGTS
            </li>
          </ul>
          <div className="overflow-hidden·rounded-lg mx-24" id="questionsref">
            <ul>
              {questionsData[selectedCategory].map((item, index) => (
                <li key={index} className="grid grid-rows-[10rem,auto] sm:grid-rows-[6rem,auto]">
                  <div className="grid grid-cols-[auto,4.5rem] rounded-t-5 bg-black pl-2 text-white shadow-md shadow-black sm:pl-10">
                    <h3 className="btn-text-2 grid items-center">{item.question}</h3>
                    <button
                      className="grid place-content-center"
                      onClick={() => toggleQuestion(index)}
                    >
                      {openQuestionIndex !== index ? (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.11111 0V7.11111H0V8.88889H7.11111V16H8.88889V8.88889H16V7.11111H8.88889V0H7.11111Z"
                            fill="#6A6A6A"
                          ></path>
                        </svg>
                      ) : (
                        <svg
                          width="16"
                          height="2"
                          viewBox="0 0 16 2"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 0.111084V1.88886H16V0.111084H0Z" fill="#6A6A6A"></path>
                        </svg>
                      )}
                    </button>
                  </div>
                  <div
                    className={`mb-12 grid grid-cols-[auto,auto,auto] overflow-hidden transition-all ease-linear ${openQuestionIndex === index ? "h-auto" : "h-0"
                      }`}
                  >
                    <span></span>
                    <span className="body-text-2 w-full rounded-b-6 border-x-1 border-b-1 border-borda-claro px-2 pb-2 pt-4 sm:px-8">
                      {item.answer}
                    </span>
                    <span></span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
